// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jk_ml","buttons":"styles_buttons__1eCsy"};